import { formatUSDFromCent } from '@helpers/utility'
import { titleCaseEachWord } from '@helpers/index'
import i18n from '../../i18n'
const { t } = i18n

export const formatWisetackStatus = ({ status, amountInCents }) => {
  const formatAmount = amountInCents ? ` for ${formatUSDFromCent(amountInCents)}` : ''

  const statusMap = {
    INITIATED: 'Pending',
    PENDING: 'Pending',
    'ACTIONS REQUIRED': 'Action Required',
    AUTHORIZED: `Approved${formatAmount}`,
    'LOAN TERMS ACCEPTED': `Offer Locked${formatAmount}`,
    'LOAN CONFIRMED': `Loan Confirmed${formatAmount}`,
    SETTLED: `Paid${formatAmount}`,
    DECLINED: 'Declined',
    EXPIRED: 'Expired',
    CANCELED: 'Canceled',
    REFUNDED: 'Refunded'
  }

  return statusMap[status] || titleCaseEachWord(status)
}

export const formatWisetackSignUpStatus = ({ status, variant }) => {
  if (status === 'NOT_STARTED') {
    const variantStatusTextMap = {
      WisetackBaseSignUpButton: t('estimates.wisetack.sign-up-now'),
      IntegrationCTAButton: t('estimates.wisetack.sign-up-for-financing')
    }

    return variantStatusTextMap[variant] || t('estimates.wisetack.sign-up-now-0')
  }

  const statusMap = {
    APPLICATION_SUBMITTED: t('estimates.wisetack.application-submitted'),
    APPLICATION_APPROVED: t('estimates.wisetack.approved'),
    APPLICATION_DECLINED: t('estimates.wisetack.declined')
  }

  return statusMap[status] || t('estimates.wisetack.continue-application')
}

export const WISETACK_RAW_STATUS = {
  APPLICATION_APPROVED: 'APPLICATION_APPROVED',
  APPLICATION_SUBMITTED: 'APPLICATION_SUBMITTED',
  APPLICATION_DECLINED: 'APPLICATION_DECLINED'
}
